<template>
  <div
    class="card border-start border-start-width-2 border-start-primary table-responsive pt-3"
  >
    <div v-if="showButtons" class="text-end mb-3">
      <button
        type="button"
        class="btn btn-outline-danger btn-icon"
        title="Exportar para PDF"
        @click="$emit('exportToPDF')"
      >
        <i class="ph-file-pdf"></i>
      </button>
      <button
        type="button"
        class="btn btn-outline-primary btn-icon mx-2"
        title="Exportar para Excel"
        @click="$emit('exportToExcel')"
      >
        <i class="ph-microsoft-excel-logo"></i>
      </button>
    </div>
    <DataTable
      :columns="dataTable.columns"
      :data="dataTable.data"
      :class="`table table-sm table-striped font-size-sm w-100 ${customClass}`"
      width="100%"
      :options="mergeOptions"
      @click="resolveRouteFromClick($event)"
    />
  </div>
</template>

<script>
import DataTable from 'datatables.net-vue3'
import DataTablesLib from 'datatables.net'

DataTable.use(DataTablesLib)

export default {
  name: 'DataTableDefault',

  props: {
    dataTable: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      required: false,
    },
    customClass: {
      type: String,
      required: false,
    },
    showButtons: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    DataTable,
  },

  data() {
    return {
      dataTableInstance: null,
      mergeOptions: {},
      defaultOptions: {
        responsive: true,
        pageLength: 10,
        lengthMenu: [10, 25, 50, 100],
        searching: true,
        info: true,
        paging: true,
        lengthChange: true,
        language: {
          url: 'https://cdn.datatables.net/plug-ins/1.10.21/i18n/Portuguese-Brasil.json',
        },
        initComplete: (settings) => {
          this.dataTableInstance = window.$(settings.nTable).DataTable()
          if (this.dataTable.search) {
            this.dataTableInstance.search(this.dataTable.search).draw()
          }
        },
      },
    }
  },

  methods: {
    resolveRouteFromClick(e) {
      e.preventDefault()

      const { itemRouter, itemEmit, itemId } = e.target.dataset

      if (itemRouter) {
        this.$emit('setSearchDataTable', this.dataTableInstance.search())
        this.$router.push(`${itemRouter}/${itemId}`)
      }
      if (itemEmit) {
        this.$emit(itemEmit, itemId)
      }
    },
  },

  beforeMount() {
    this.mergeOptions = { ...this.defaultOptions, ...this.options }
  },
}
</script>

<style>
.dataTables_wrapper {
  margin: auto 10px;
}

.dataTables_length select {
  width: 85px;
  margin-right: 10px;
}

.dataTables_paginate > ul,
.dataTables_filter > label {
  justify-content: end;
}

.dataTables_filter input {
  margin-left: 10px;
}

.dataTables_wrapper > div:nth-child(3) {
  margin-top: 15px;
  align-items: center;
}
</style>
